<button-back>
    <button type="button" class="text-sm font-semibold leading-6 text-gray-900" onclick="history.back()">{ props.text ? props.text : 'Indietro' }</button>
</button-back>
